import { useState } from 'react';

// Hooks
import { NEXT_STEP, useAlbumContext } from '@/utils/hooks/context/useAlbumContext';
import useTranslation from '@/utils/hooks/translation/useTranslation';

// Lib
import { ALBUM_TYPE_MANUAL, albumTypes } from '@/lib/albums/albumFunnel/types';

import Button from '@/components/base/Button';
// Components
import Label from '@/components/base/Label';
import Modal from '@/components/base/Modal';
import AlbumTypeCard from '@/components/pages/albums/AlbumFunnelModal/ModalSteps/SelectTypeStep/AlbumTypeCard';
import InputAlbumName from '@/components/pages/albums/AlbumFunnelModal/components/InputAlbumName';

export const SelectTypeStep = ({
    dismiss = () => {
        /** */
    }
}) => {
    const { t } = useTranslation('content');
    const { albumInfo, dispatch } = useAlbumContext();
    const [activeType, setActiveType] = useState(albumInfo?.type ?? ALBUM_TYPE_MANUAL);

    return (
        <div className="w-[calc(100vw-24px)] sm:max-w-[37.5rem]">
            <Modal.Body>
                <Modal.Title>{t('modal.create_modal.title')}</Modal.Title>
                <Modal.Content className="mt-8 space-y-8 rounded-md bg-icoGray-100 p-5 dark:bg-icoDarkMode-deepBlack sm:p-8">
                    <div>
                        <InputAlbumName />
                    </div>
                    <div>
                        <Label required className="mb-2.5">
                            {t('content:modal.create_modal.select_type')}
                        </Label>
                        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
                            {albumTypes?.map((albumType, index) => (
                                <AlbumTypeCard
                                    key={index}
                                    data-testid={`card-album-type-${albumType.type}`}
                                    image={albumType.image}
                                    title={t(albumType.title)}
                                    description={t(albumType.description)}
                                    isSelected={activeType === albumType.type}
                                    onClick={() => setActiveType(albumType?.type ?? 'manual')}
                                />
                            ))}
                        </div>
                    </div>
                </Modal.Content>
            </Modal.Body>
            <Modal.Footer>
                <button
                    onClick={dismiss}
                    className="font-GMedium text-xs text-icoGray-500 underline dark:text-icoDarkMode-wolf">
                    {t('commons:cancel')}
                </button>
                <Button
                    id="select-campaign-type-next-step-button"
                    className="w-48"
                    disabled={albumInfo?.name === ''}
                    onClick={() =>
                        dispatch({
                            type: NEXT_STEP,
                            payload: activeType
                        })
                    }>
                    {t('commons:next')}
                </Button>
            </Modal.Footer>
        </div>
    );
};
